
<!-- Do not delete strange attributes!!! This is necessary so that Google does not autocomplete inputs :) -->
<form autocomplete="off">
  <label class="search">
    <input type="text" name="search" autocomplete="off" id="country"
           [ngClass]="{
          'have-value': searchControl.value,
          'empty-result': (lastResultIsEmpty$ | async)?.empty && searchControl.value
         }"
           [formControl]="searchControl"
           [placeholder]="placeholder"/>
    <mat-icon *ngIf="searchControl.value" (click)="searchControl.setValue('')">close</mat-icon>
  </label>
</form>
